import React from 'react';
import styled from '@benzinga/themetron';
import { EntityAttributeDisplay } from './EntityAttributeDisplay';
import { EntityAttribute } from '@benzinga/content-manager';
import { Card } from '@benzinga/core-ui';

interface EntityAttributeCardProps {
  attribute: EntityAttribute;
}

export const EntityAttributeCard: React.FC<EntityAttributeCardProps> = ({ attribute }) => {
  return (
    <AttributeCardWrapper>
      <EntityAttributeDisplay attribute={attribute} />
    </AttributeCardWrapper>
  );
};

const AttributeCardWrapper = styled(Card)`
  padding: 0;
  .entity-attr {
    .label {
      display: block;
      font-weight: bold;
      margin-bottom: 0.5rem;
    }
  }
`;
